import { FC } from "react";
import { Box, Spacer } from "@smile2impress/components/relaunch";

import { ClinicsListProps } from "./ClinicsList.types";
import { ClinicGrid } from "../ClinicGrid";

export const ClinicsList: FC<ClinicsListProps> = ({
    titleForFirstList,
    titleForSecondList,
    titleForThirdList,
    disclaimerForSecondList,
    defaultClinics,
    flagshipClinics,
    b2bClinics,
}) => {
    return (
        <Box px={[0, 0, 4]}>
            <ClinicGrid title={titleForFirstList} clinics={flagshipClinics} />
            {titleForSecondList && (
                <>
                    <Spacer mt={[4, 4, 5]} />
                    <ClinicGrid
                        title={titleForSecondList}
                        clinics={defaultClinics}
                        disclaimer={disclaimerForSecondList}
                        showInfoText
                    />
                </>
            )}
            {titleForThirdList && b2bClinics && b2bClinics.length > 0 && (
                <>
                    <Spacer mt={[4, 4, 5]} />
                    <ClinicGrid
                        title={titleForThirdList}
                        clinics={b2bClinics}
                        disclaimer={disclaimerForSecondList}
                        showInfoText
                    />
                </>
            )}
        </Box>
    );
};
